export default "__VITE_ASSET__ae7a6a01__"